<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="配置名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'name', validatorRules.name]" placeholder="请输入配置名"></a-input>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remark', validatorRules.remark]" placeholder="备注"></a-input>
        </a-form-item>
        <a-form-item label="存储器" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['storage', validatorRules.storage]" :trigger-change="true"
                             @change="storageChange"
                             dictCode="infra_file_storage" placeholder="请选择存储器"/>
        </a-form-item>
        <a-form-item label="基础路径" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-if="currentStorage >= 10 && currentStorage <= 12">
          <a-input v-decorator="[ 'config.basePath', validatorRules.config.basePath]" placeholder="请输入基础路径"></a-input>
        </a-form-item>
        <a-form-item label="主机地址" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-if="currentStorage >= 11 && currentStorage <= 12">
          <a-input v-decorator="[ 'config.host', validatorRules.config.host]" placeholder="请输入主机地址"></a-input>
        </a-form-item>
        <a-form-item label="主机端口" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-if="currentStorage >= 11 && currentStorage <= 12">
          <a-input v-decorator="[ 'config.port', validatorRules.config.port]" placeholder="请输入主机端口"></a-input>
        </a-form-item>
        <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-if="currentStorage >= 11 && currentStorage <= 12">
          <a-input v-decorator="[ 'config.username', validatorRules.config.username]" placeholder="请输入用户名"></a-input>
        </a-form-item>
        <a-form-item label="密码" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-if="currentStorage >= 11 && currentStorage <= 12">
          <a-input v-decorator="[ 'config.password', validatorRules.config.password]" placeholder="请输入密码"></a-input>
        </a-form-item>
        <a-form-item label="连接模式" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-if="currentStorage == 11">
          <a-radio-group v-decorator="[ 'config.mode', validatorRules.config.mode]">
            <a-radio value="Active">主动模式</a-radio>
            <a-radio value="Passive">被动模式</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="节点地址" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-if="currentStorage == 20">
          <a-input v-decorator="[ 'config.endpoint', validatorRules.config.endpoint]" placeholder="请输入节点地址"></a-input>
        </a-form-item>
        <a-form-item label="存储 bucket" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-if="currentStorage == 20">
          <a-input v-decorator="[ 'config.bucket', validatorRules.config.bucket]" placeholder="请输入存储 bucket"></a-input>
        </a-form-item>
        <a-form-item label="accessKey" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-if="currentStorage == 20">
          <a-input v-decorator="[ 'config.accessKey', validatorRules.config.accessKey]" placeholder="请输入 accessKey"></a-input>
        </a-form-item>
        <a-form-item label="accessSecret" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-if="currentStorage == 20">
          <a-input v-decorator="[ 'config.accessSecret', validatorRules.config.accessSecret]" placeholder="请输入 accessSecret"></a-input>
        </a-form-item>
        <a-form-item label="自定义域名" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-if="currentStorage == 20">
          <a-input v-decorator="[ 'config.domain', validatorRules.config.domain]" placeholder="请输入自定义域名"></a-input>
        </a-form-item>
        <a-form-item label="自定义域名" :labelCol="labelCol" :wrapperCol="wrapperCol"
                     v-else-if="currentStorage">
          <a-input v-decorator="[ 'config.domain', validatorRules.config.domain]" placeholder="请输入自定义域名"></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JDictSelectTag from "@/components/dict/JDictSelectTag"

export default {
  name: "BusAssetStorageDetailModal",
  components: {
    JDictSelectTag,
  },
  data () {
    return {
      form: this.$form.createForm(this),
      title:"操作",
      width:800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        name: {rules: [
          ]},
        storage: {rules: [
          ]},
        remark: {rules: [
          ]},
        config: {
          basePath: {rules: [
            ]},
          host: {rules: [
            ]},
          port: {rules: [
            ]},
          username: {rules: [
            ]},
          password: {rules: [
            ]},
          endpoint: {rules: [
            ]},
          bucket: {rules: [
            ]},
          accessKey: {rules: [
            ]},
          accessSecret: {rules: [
            ]},
          domain: {rules: [
            ]}
        }
      },
      url: {
        add: "/file.base/file-config/create",
        edit: "/file.base/file-config/update",
        get: "/file.base/file-config/get",
      },
      currentStorage: null,
    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({});
    },
    edit (record) {
      this.form.resetFields();
      this.currentStorage = null

      this.model = Object.assign({}, record);
      this.visible = true;
      this.get(record)
      // this.$nextTick(() => {
      //   this.form.setFieldsValue(pick(this.model,'name','remark','databaseSpaceSize','databaseType','business','applicationDescription','responsiblePerson','isBackup','backupStrategy','backupMechanism','backupPath','storageMedium','backupTimePoint','backupFrequency','backupTime','retentionDays','backupFileSize','remark'))
      // })
    },
    async get(record) {
      let res = await getAction(this.url.get, {
        id: record.id
      })
      console.log('配置信息明细======》', res.result)
      this.currentStorage = res.result.storage
      this.$nextTick(() => {
        this.form.setFieldsValue(res.result)
      })
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleOk () {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if(!this.model.id){
            httpurl+=this.url.add;
            method = 'post';
          }else{
            httpurl+=this.url.edit;
            method = 'put';
          }
          let formData = Object.assign(this.model, values);
          console.log("表单提交数据",formData)
          httpAction(httpurl,formData,method).then((res)=>{
            if(res.success){
              that.$message.success(res.message);
              that.$emit('ok');
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
            that.close();
          })
        }

      })
    },
    handleCancel () {
      this.close()
    },
    popupCallback(row){
      this.form.setFieldsValue(pick(row,'databaseAddress','databaseName','databaseSpaceSize','databaseType','business','applicationDescription','responsiblePerson','isBackup','backupStrategy','backupMechanism','backupPath','storageMedium','backupTimePoint','backupFrequency','backupTime','retentionDays','backupFileSize','remark'))
    },
    storageChange(e) {
      console.log('存储器改变====》', e)
      this.currentStorage = e
    }


  }
}
</script>